import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./SideBar.css";
import NAV_GROUPS from "./navItems";
import ADMIN_LOGO from "./adminLogo";

const COPY = {
  logout: "Logout",
  closeMenu: "Close menu",
  openMenu: "Open menu",
};

// One nav row. Shared by the desktop rail and the mobile drawer so the two can
// never drift apart.
const NavItem = ({ item, expanded, onNavigate }) => {
  const Icon = item.icon;

  return (
    <NavLink
      to={item.path}
      onClick={onNavigate}
      title={expanded ? undefined : item.name}
      className={({ isActive }) =>
        `admin-nav-link ${isActive ? "admin-nav-link--active" : ""} ${
          expanded ? "" : "admin-nav-link--collapsed"
        }`
      }
    >
      <Icon size={17} strokeWidth={2} className="shrink-0" />
      {expanded && <span className="truncate">{item.name}</span>}
    </NavLink>
  );
};

const NavGroups = ({ expanded, onNavigate }) => (
  <nav className="flex flex-col gap-5 px-3 pb-6">
    {NAV_GROUPS.map((group) => (
      <div key={group.label} className="flex flex-col gap-1">
        {expanded && <p className="admin-nav-heading">{group.label}</p>}
        {group.items.map((item) => (
          <NavItem
            key={item.path}
            item={item}
            expanded={expanded}
            onNavigate={onNavigate}
          />
        ))}
      </div>
    ))}
  </nav>
);

const SideBarAdmin = (props) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleRail = () => {
    setIsOpen(!isOpen);
    props.setRightHeader(!props.rightHeader);
  };

  const goHome = () => navigate("/");

  const logout = () => {
    localStorage.removeItem("admin");
    localStorage.removeItem("loggedin");
    localStorage.removeItem("token");
    navigate("/admin");
  };

  return (
    <>
      {/* Desktop rail */}
      <aside
        className="admin-sidebar"
        style={{ width: isOpen ? "244px" : "72px" }}
      >
        <div className="flex items-center justify-between gap-2 px-3 py-5">
          {isOpen && (
            <img
              src={ADMIN_LOGO}
              alt="The Crypto Hub"
              onClick={goHome}
              className="h-7 w-auto cursor-pointer"
            />
          )}
          <button
            type="button"
            onClick={toggleRail}
            aria-label={isOpen ? COPY.closeMenu : COPY.openMenu}
            className="admin-icon-btn"
          >
            <Menu size={16} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto admin-scroll">
          <NavGroups expanded={isOpen} />
        </div>

        <button type="button" onClick={logout} className="admin-logout">
          <LogOut size={17} className="shrink-0" />
          {isOpen && <span>{COPY.logout}</span>}
        </button>
      </aside>

      {/* Mobile trigger + drawer */}
      <button
        type="button"
        onClick={() => setMobileOpen(true)}
        aria-label={COPY.openMenu}
        className="admin-mobile-trigger"
      >
        <Menu size={20} />
      </button>

      <Offcanvas
        show={mobileOpen}
        onHide={() => setMobileOpen(false)}
        placement="start"
        className="admin-offcanvas"
      >
        <Offcanvas.Header>
          <img
            src={ADMIN_LOGO}
            alt="The Crypto Hub"
            onClick={goHome}
            className="h-8 w-auto cursor-pointer"
          />
          <button
            type="button"
            onClick={() => setMobileOpen(false)}
            aria-label={COPY.closeMenu}
            className="admin-icon-btn"
          >
            <X size={18} />
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <NavGroups expanded onNavigate={() => setMobileOpen(false)} />
          <button type="button" onClick={logout} className="admin-logout">
            <LogOut size={18} />
            <span>{COPY.logout}</span>
          </button>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SideBarAdmin;
